import React from 'react';
import { FontIcon, mergeStyles, Stack } from 'office-ui-fabric-react';
import { SubHeading, SubHeadingLevel } from '../Typography/sub-heading';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const SystemPanel = _ref => {
  let {
    iconName,
    iconColour,
    title,
    content
  } = _ref;
  const iconClass = mergeStyles({
    fontSize: 50,
    height: 50,
    width: 50,
    margin: '0 25px',
    color: iconColour
  });
  return /*#__PURE__*/_jsx(Stack, {
    styles: {
      root: {
        padding: '60px'
      }
    },
    children: /*#__PURE__*/_jsx(Stack.Item, {
      align: "center",
      children: /*#__PURE__*/_jsxs(Stack, {
        horizontal: true,
        styles: {
          root: {
            padding: '50px'
          }
        },
        tokens: {
          childrenGap: 5
        },
        children: [/*#__PURE__*/_jsx(Stack, {
          children: /*#__PURE__*/_jsx(FontIcon, {
            iconName: iconName,
            className: iconClass
          })
        }), /*#__PURE__*/_jsxs(Stack, {
          tokens: {
            childrenGap: 20
          },
          children: [/*#__PURE__*/_jsx(SubHeading, {
            headingLevel: SubHeadingLevel.Level1,
            children: title
          }), content]
        })]
      })
    })
  });
};